import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
dayjs.extend(relativeTime);

export default {
  install(Vue) {
    Vue.prototype.$time = function(content) {
      if (!content) {
        return "";
      }
      return dayjs(content).fromNow();
    };

    Vue.prototype.$formatTime = function(content, format) {
      if (!content) {
        return "";
      }
      return dayjs(content).format(format || "YYYY-MM-DD");
    };

    Vue.prototype.$relativeTime = function(content) {
      if (!content) {
        return "";
      }

      return dayjs(content).from(dayjs());
    };
  }
};
